import React from 'react';

const NavigationContext = React.createContext({
  mobileNavigation: false,
  setShowMobileNavigation: () => {},
});

export default NavigationContext;
